/**
 * SOUND-650 — how a ticket number is written, in one place.
 *
 * Tickets display as `SC-412`. The prefix is merchant-facing: clients handle
 * tickets from many vendors, and one they recognise as Sound is worth more than
 * the brevity of a bare number. It is deliberately NOT `SOUND-`, which is the
 * Jira project key — `SOUND-412` would be genuinely ambiguous between a CRM
 * ticket and a Jira issue, and both exist.
 *
 * This lives in a utility because the number was previously rendered as `#{n}`
 * at 13 separate call sites across 6 files. A prefix hardcoded 13 times is a
 * prefix that will eventually be written 2 different ways.
 *
 * The number itself stays an integer in the database — the prefix is display
 * only, so sorting stays numeric and search still matches on the value. The
 * server accepts "412", "#412" and "SC-412" for lookups (parseTicketNumber in
 * sound-api).
 */

export const TICKET_PREFIX = "SC";

/**
 * `412` → `"SC-412"`. Returns "" for a missing number rather than "SC-undefined",
 * so a caller that renders it unconditionally degrades to blank.
 */
export function ticketRef(number) {
  if (number === null || number === undefined || number === "") return "";
  return `${TICKET_PREFIX}-${number}`;
}
